package com.macrofocus.eflux.ui.perspective

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.components.blurBackground
import js.objects.unsafeJso
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import org.mkui.component.CPComponent
import org.mkui.react.useProperty
import react.FC
import react.Props
import web.cssom.Position
import web.cssom.px

class SearchPerspective(private val dataLoader: DataLoader) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> {
        val theme = useTheme<Theme>()

        val (substationNetwork, _) = useProperty(dataLoader.substationNetwork)

        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Paper {
            sx = unsafeJso {
                position = Position.absolute
                top = 0.px
//                bottom = 0.px
                left = 0.px
                right = 0.px

                customBackground(this)
            }

            Search {}
        }
    }
}
